/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

/**
 * setViewURICommand.js --
 *
 * Pass the View URI to JSCDK.
 *
 */

import UrlHandler from "../controllers/urlHandler";
import util from "../util";
import { globalArray } from "../jscdkClient";

export default function SetViewURICommand() {}

/**
 * Invoked by JSCDKController
 *
 * @param setViewURIAction[in]
 *        - its property 'method' has the value 'SetViewURI'
 */
SetViewURICommand.prototype.execute = function (setViewURIAction) {
   let urlHandler = util.getObject(globalArray, "url-handler"),
      url = setViewURIAction ? setViewURIAction.queryString : "";

   if (!urlHandler) {
      urlHandler = new UrlHandler();
      globalArray[urlHandler.name] = urlHandler;
   }

   urlHandler.handleUrlParams(url);
};
